import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { SKIN } from '../../../constants'

const styles = {
  svg: {
    userSelect: "none",
    MozUserSelect: "none",
    MsUserSelect: "none",
    KhtmlUserSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)",
  },
  text: {
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`
  }
}

class RenjuBoard extends React.Component {
  render() {
    const {
      classes,
      viewPort,
      boardWidth,
      boardHeight,
      rectProp,
      linesProp,
      starCircleProp,
      coordinateXProp,
      coordinateYProp,
      stonesProp,
      numbersProp,
      marksProp,
      forbiddenProp,
      fiveMovesProp,
      nextMoveProp,
      colorProp,
      lastMoveMarkProp,
      isVisibleCoordinate,
      isVisibleNextMove,
      isVisibleNumber,
      isVisibleLastMoveMark,
      skin,
      headerContent,
      clossProps,
      circleProps
    } = this.props

    if (skin === SKIN.CARO) {
      return (
        <svg className={classes.svg} width={boardWidth} height={boardHeight} viewBox={viewPort}>
          <defs>
            <g id="closs">
              <path style={{ fill: "#0071bc" }} d="M24.24,20l5.88-5.88a3,3,0,0,0-4.24-4.24L20,15.76,14.12,9.88a3,3,0,0,0-4.24,4.24L15.76,20,9.88,25.88a3,3,0,0,0,0,4.24,3,3,0,0,0,4.24,0L20,24.24l5.88,5.88a3,3,0,0,0,4.24,0,3,3,0,0,0,0-4.24Z" />
            </g>
            <g id="circle">
              <path style={{ fill: "#d1272d" }} d="M20,32A12,12,0,1,1,32,20,12,12,0,0,1,20,32Zm0-18a6,6,0,1,0,6,6A6,6,0,0,0,20,14Z" />
            </g>
          </defs>
        {headerContent && headerContent}
        {linesProp.map((prop, index) => 
          <line x1={prop.x1} y1={prop.y1} x2={prop.x2} y2={prop.y2} fill='none' stroke={colorProp.board} strokeLinejoin='round' strokeWidth='2' key={index}/>
        )}
        <rect x={rectProp.x} y={rectProp.y} width={rectProp.width} height={rectProp.height} fill='none' stroke={colorProp.board} strokeLinejoin='round' strokeWidth='4' />
        {starCircleProp.map((prop, index) =>
          <circle cx={prop.cx} cy={prop.cy} r='4' fill={colorProp.board} key={index} />
        )}
        {isVisibleCoordinate && coordinateXProp.map((prop, index) => 
          <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill={colorProp.coordinate} key={index}>{prop.str}</text>
        )}
        {isVisibleCoordinate && coordinateYProp.map((prop, index) => 
          <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill={colorProp.coordinate} key={index}>{prop.str}</text>
        )}
        {isVisibleLastMoveMark && lastMoveMarkProp && (
          <rect x={lastMoveMarkProp.x} y={lastMoveMarkProp.y} width={lastMoveMarkProp.width} height={lastMoveMarkProp.height} fill={lastMoveMarkProp.color}/>
        )}
        {clossProps.map((prop, index) =>
          <use xlinkHref="#closs" key={index} x={prop.x} y={prop.y}/>
        )}
        {circleProps.map((prop, index) =>
          <use xlinkHref="#circle" key={index} x={prop.x} y={prop.y}/>
        )}
        {isVisibleNumber && numbersProp.map((prop, index) => (
          <React.Fragment  key={index}>
            <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill={"#ffffff"} stroke={"#ffffff"} strokeWidth={4} strokeLinejoin={"round"} style={{ fontSize: '0.75rem' }}>{prop.number}</text>
            <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill={prop.color} style={{ fontSize: '0.75rem' }}>{prop.number}</text>
          </React.Fragment>
        ))}
        {forbiddenProp.map((prop, index) =>
          <circle cx={prop.cx} cy={prop.cy} r='15' fill='#fff' key={index} />
        )}
        {forbiddenProp.map((prop, index) =>
          <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill='#000' key={index}>×</text>
        )}
        {fiveMovesProp.map((prop, index) => 
          <circle cx={prop.cx} cy={prop.cy} r='10' fill={colorProp.fill} key={index} />
        )}
        {marksProp.map((prop, index) =>
          <circle cx={prop.cx} cy={prop.cy} r='15' fill='#fff' key={index} />
        )}
        {marksProp.map((prop, index) =>
          <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill='#000' key={index}>{prop.str}</text>
        )}
        {isVisibleNextMove && nextMoveProp && (
          <circle cx={nextMoveProp.cx} cy={nextMoveProp.cy} r="19" fill='none' stroke='#777777' strokeMiterlimit='3' strokeDasharray='3,3'/>
        )}
        </svg>
      )
    }
    return (
      <svg className={classes.svg} width={boardWidth} height={boardHeight} viewBox={viewPort}>
      {headerContent && headerContent}
      {linesProp.map((prop, index) => 
        <line x1={prop.x1} y1={prop.y1} x2={prop.x2} y2={prop.y2} fill='none' stroke={colorProp.board} strokeLinejoin='round' strokeWidth='2' key={index}/>
      )}
      <rect x={rectProp.x} y={rectProp.y} width={rectProp.width} height={rectProp.height} fill='none' stroke={colorProp.board} strokeLinejoin='round' strokeWidth='4' />
      {starCircleProp.map((prop, index) =>
        <circle cx={prop.cx} cy={prop.cy} r='4' fill={colorProp.board} key={index} />
      )}
      {isVisibleCoordinate && coordinateXProp.map((prop, index) => 
        <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill='#000' key={index}>{prop.str}</text>
      )}
      {isVisibleCoordinate && coordinateYProp.map((prop, index) => 
        <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill='#000' key={index}>{prop.str}</text>
      )}
      {stonesProp.map((prop, index) =>
        <circle cx={prop.cx} cy={prop.cy} r={prop.r} fill={prop.color} key={index} />
      )}
      {isVisibleLastMoveMark && lastMoveMarkProp && (
        <circle cx={lastMoveMarkProp.cx} cy={lastMoveMarkProp.cy} r={lastMoveMarkProp.r} fill={lastMoveMarkProp.color}/>
      )}
      {isVisibleNumber && numbersProp.map((prop, index) =>
        <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill={prop.color} key={index}>{prop.number}</text>
      )}
      {forbiddenProp.map((prop, index) =>
        <circle cx={prop.cx} cy={prop.cy} r='15' fill='#fff' key={index} />
      )}
      {forbiddenProp.map((prop, index) =>
        <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill='#000' key={index}>×</text>
      )}
      {fiveMovesProp.map((prop, index) => 
        <circle cx={prop.cx} cy={prop.cy} r='10' fill={colorProp.fill} key={index} />
      )}
      {marksProp.map((prop, index) =>
        <circle cx={prop.cx} cy={prop.cy} r='15' fill='#fff' key={index} />
      )}
      {marksProp.map((prop, index) =>
        <text className={classes.text} x={prop.x} y={prop.y} textAnchor="middle" dominantBaseline="central" fill='#000' key={index}>{prop.str}</text>
      )}
      {isVisibleNextMove && nextMoveProp && (
        <circle cx={nextMoveProp.cx} cy={nextMoveProp.cy} r="19" fill='none' stroke='#777777' strokeMiterlimit='3' strokeDasharray='3,3'/>
      )}
      </svg>
    )
  }
}

export default withStyles(styles)(RenjuBoard);


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoard/RenjuBoard.js